import { CheckCircle2, Clock, XCircle, Award } from 'lucide-react';

export const DEFAULT_COSTS = {
  'SHOficina': 125.00,
  'SHNF-e - Emissor NF-e': 180.00,
  'SHNFC-e - Cupom Fiscal': 190.00,
  'SHNFS-e - Nota de Serviços': 200.00,
};

export const STATUS_LIST = [
  { id: 'approved', label: 'Aprovado', color: 'green', icon: CheckCircle2 },
  { id: 'pending', label: 'Pendente', color: 'yellow', icon: Clock },
  { id: 'license_generated', label: 'Licença Gerada', color: 'blue', icon: Award },
  { id: 'rejected', label: 'Rejeitado', color: 'red', icon: XCircle },
  { id: 'cancelled', label: 'Cancelado', color: 'red', icon: XCircle },
  { id: 'refunded', label: 'Reembolsado', color: 'orange', icon: XCircle },
];

export const getCostForItem = (itemName, costConfig) => {
  for (const [key, cost] of Object.entries(costConfig)) {
    if (itemName.includes(key)) return cost;
  }
  return 0;
};

export const formatDate = (dateStr) => {
  if (!dateStr) return '-';
  return new Date(dateStr).toLocaleDateString('pt-BR', {
    day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
  });
};

export const formatCurrency = (value) =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value || 0);

export const formatCPF = (cpf) => cpf ? cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4') : '-';
export const formatCNPJ = (cnpj) => cnpj ? cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5') : '-';
export const formatPhone = (phone) => {
  if (!phone) return '-';
  if (phone.length === 11) return phone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
  if (phone.length === 10) return phone.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
  return phone;
};

export const getStatusInfo = (status) => {
  if (status === 'license_generated') return { label: 'Licença Gerada', color: 'blue', Icon: Award };
  if (status === 'approved') return { label: 'Aprovado', color: 'green', Icon: CheckCircle2 };
  if (status === 'refunded') return { label: 'Reembolsado', color: 'orange', Icon: XCircle };
  if (['rejected', 'cancelled'].includes(status))
    return { label: status === 'cancelled' ? 'Cancelado' : 'Rejeitado', color: 'red', Icon: XCircle };
  return { label: 'Pendente', color: 'yellow', Icon: Clock };
};

export const getLicenseStatus = (order) => {
  if (!order.license_expires_at) return null;
  const expires = new Date(order.license_expires_at);
  const diffDays = Math.ceil((expires - new Date()) / (1000 * 60 * 60 * 24));
  if (diffDays <= 0) return { label: 'EXPIRADA', days: 0, color: 'red', expired: true };
  if (diffDays <= 30) return { label: `Expira em ${diffDays} dias`, days: diffDays, color: 'red', expired: false };
  if (diffDays <= 90) return { label: `Expira em ${diffDays} dias`, days: diffDays, color: 'yellow', expired: false };
  const months = Math.floor(diffDays / 30);
  return { label: `Expira em ${months} meses (${diffDays}d)`, days: diffDays, color: 'green', expired: false };
};
